import { TreeViewBaseItem } from "@mui/x-tree-view"

export enum ScenarioTreeNodeType {
  ORGANISATION = "ORGANISATION",
  DIVISION = "DIVISION",
  PRODUCT = "PRODUCT",
  FAMILY = "FAMILY",
}

export type ScenarioTreeNodeBase<TChild extends TreeViewBaseItem = TreeViewBaseItem> = {
  type: ScenarioTreeNodeType
  id: string
  label: string
  children: TChild[]
}

export type ScenarioTreeNode = OrganisationNode | DivisionNode | ProductNode | FamilyNode

export type OrganisationNode = ScenarioTreeNodeBase<DivisionNode> & {
  type: ScenarioTreeNodeType.ORGANISATION
  organisationKey: string
}

export type DivisionNode = ScenarioTreeNodeBase<ProductNode> & {
  type: ScenarioTreeNodeType.DIVISION
  organisationKey: string
  divisionKey: string
}

export type ProductNode = ScenarioTreeNodeBase<FamilyNode> & {
  type: ScenarioTreeNodeType.PRODUCT
  organisationKey: string
  divisionKey: string
  productKey: string
  hasFetchedFamilies: boolean
}

export type FamilyNode = ScenarioTreeNodeBase & {
  type: ScenarioTreeNodeType.FAMILY
  organisationKey: string
  divisionKey: string
  productKey: string
  familyKey: string
  fullFamilyKey: string
  children: []
}
